import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { EliquaCXConfigurationState } from '../reducers/eliqua-cx.configuration.reducer';
import * as selectors from '../selectors/eliqua-cx-configuration.selectors';

@Injectable()
export class EliquaCXConfigurationFacadeService extends FacadeService {
  constructor(public override store: Store<EliquaCXConfigurationState>) {
    super(store);
  }

  nameEliquaCX$ = this.storeSelect(selectors.getNameEliquaCX);
  integrationCodeEliquaCX$ = this.storeSelect(selectors.getIntegrationCodeEliquaCX);
  statusEliquaCX$ = this.storeSelect(selectors.getStatusEliquaCX);
  schemaCodeEliquaCX$ = this.storeSelect(selectors.getSchemaCodeEliquaCX);
  idpAccountEliquaCX$ = this.storeSelect(selectors.getIdpAccountEliquaCX);
  baseURLEliquaCX$ = this.storeSelect(selectors.getBaseURLEliquaCX);
  usernameEliquaCX$ = this.storeSelect(selectors.getUsernameEliquaCX);
  passwordEliquaCX$ = this.storeSelect(selectors.getPasswordEliquaCX);

  rootConfigurationHelpTextStatus$ = this.storeSelect(selectors.getRootConfigurationHelpTextStatus);
  credentialsConfigurationHelpTextStatus$ = this.storeSelect(
    selectors.getCredentialsConfigurationHelpTextStatus,
  );
  endpointConfigurationHelpTextStatus$ = this.storeSelect(
    selectors.getEndpointConfigurationHelpTextStatus,
  );
  selectedEliquaCXDataFromGrid$ = this.storeSelect(selectors.getSelectedEliquaCXDataFromGrid);
  showUpdateBtn$ = this.storeSelect(selectors.getShowUpdateBtn);
  showCancelBtn$ = this.storeSelect(selectors.getShowCancelBtn);
  showNameErrorMsg$ = this.storeSelect(selectors.getShowNameErrorMsg);
  showIntegrationCodeErrorMsg$ = this.storeSelect(selectors.getShowIntegrationCodeErrorMsg);
  showSchemaCodeErrorMsg$ = this.storeSelect(selectors.getShowSchemaCodeErrorMsg);
  showIdpAccountErrorMsg$ = this.storeSelect(selectors.getShowIdpAccountErrorMsg);
  showBaseUrlErrorMsg$ = this.storeSelect(selectors.getShowBaseUrlErrorMsg);
  showUsernameErrorMsg$ = this.storeSelect(selectors.getShowUsernameErrorMsg);
  showPasswordErrorMsg$ = this.storeSelect(selectors.getShowPasswordErrorMsg);
  disableNameValue$ = this.storeSelect(selectors.getDisableNameValue);
  disableIntegrationCodeValue$ = this.storeSelect(selectors.getDisableIntegrationCodeValue);
  isDataValid$ = this.storeSelect(selectors.getEliquaCXDataIsValid);

  get nameEliquaCX() {
    return this.storeSnapshot(this.nameEliquaCX$);
  }

  get integrationCodeEliquaCX() {
    return this.storeSnapshot(this.integrationCodeEliquaCX$);
  }

  get statusEliquaCX() {
    return this.storeSnapshot(this.statusEliquaCX$);
  }

  get schemaCodeEliquaCX() {
    return this.storeSnapshot(this.schemaCodeEliquaCX$);
  }

  get idpAccountEliquaCX() {
    return this.storeSnapshot(this.idpAccountEliquaCX$);
  }

  get baseURLEliquaCX() {
    return this.storeSnapshot(this.baseURLEliquaCX$);
  }

  get usernameEliquaCX() {
    return this.storeSnapshot(this.usernameEliquaCX$);
  }

  get passwordEliquaCX() {
    return this.storeSnapshot(this.passwordEliquaCX$);
  }

  get showUpdateBtn() {
    return this.storeSnapshot(this.showUpdateBtn$);
  }

  get showCancelBtn() {
    return this.storeSnapshot(this.showCancelBtn$);
  }

  get selectedEliquaCXDataFromGrid() {
    return this.storeSnapshot(this.selectedEliquaCXDataFromGrid$);
  }

  get isDataValid() {
    return this.storeSnapshot(this.isDataValid$);
  }

  getEliquaCX_DTO() {
    const name = this.nameEliquaCX;
    const integrationCode = this.integrationCodeEliquaCX;
    const status = this.statusEliquaCX;
    const schemaCode = this.schemaCodeEliquaCX;
    const idpAccount = this.idpAccountEliquaCX;
    const baseURL = this.baseURLEliquaCX;
    const username = this.usernameEliquaCX;
    const password = this.passwordEliquaCX;

    const eliquaCX_DTO = {
      integrationCode,
      deleted: status,
      integrationConfig: {
        integrationSystem: 'ELIQUA_CX',
        integrationDisplayName: name,
        schemaCode: schemaCode,
        idpAccount: idpAccount,
      },
      endpointConfiguration: {
        code: integrationCode,
        endpointConfig: {
          type: 'HTTP',
          method: 'POST',
          baseURL,
          headers: {
            'Content-Type': 'application/json',
          },
          skipSSL: false,
          pathParams: {},
          queryParams: {},
          dateFormat: null,
          requestContentType: 'application/json',
          responseContentType: 'application/json',
        },
        credentialConfig: {
          type: 'HTTP_BASIC',
          bypassEncryption: false,
          username: username,
          password: password,
        },
      },
    };

    return eliquaCX_DTO;
  }
}
